import { PaginationState } from '@/types/commonFilters.types';
import { GridPaginationModel, GridSortModel } from '@mui/x-data-grid-pro';
import { useCallback, useState } from 'react';

const DEFAULT_PAGE_SIZE = 15;
export type GridPaginationAndSortFilters = Partial<PaginationState> & { sort?: GridSortModel };

interface IProps {
  setFilters: (filters: GridPaginationAndSortFilters) => void;
  pageSize?: number;
  defaultSortModel?: GridSortModel;
}

export const useGridApiPaginationAndSort = ({ setFilters, pageSize = DEFAULT_PAGE_SIZE, defaultSortModel }: IProps) => {
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize,
  });

  const [sortModel, setSortModel] = useState<GridSortModel>(defaultSortModel ?? []);

  const setPagination = useCallback(
    (pagination: PaginationState) => {
      setFilters(pagination);
    },
    [setFilters],
  );

  const setSort = useCallback((sort: GridSortModel) => setFilters({ sort }), [setFilters]);

  const handlePaginationModelChange = useCallback(
    (newPaginationModel: GridPaginationModel) => {
      setPaginationModel(newPaginationModel);
      setPagination({ page: newPaginationModel.page + 1, limit: newPaginationModel.pageSize });
    },
    [setPagination],
  );

  const handleSortModelChange = useCallback(
    (newSortModel: GridSortModel) => {
      setSortModel(newSortModel);
      setSort(newSortModel);
    },
    [setSort],
  );

  const handleReset = useCallback(() => {
    setPaginationModel({ page: 0, pageSize });
    setSortModel([]);
    setFilters({
      page: 0,
      limit: pageSize,
      sort: [],
    });
  }, [setFilters, pageSize]);

  return {
    paginationModel,
    sortModel,
    handlePaginationModelChange,
    handleSortModelChange,
    handleReset,
  };
};
